export default (navigator = window.navigator) =>
  /android/i.test(navigator.userAgent)
